import React, { useState } from 'react';
import Logo from '../assets/images/logo.png';
import { Button, Card, Col, Form, Input, message, Row } from 'antd';
import { requestRequestResetPasswordApi } from '@/store/requests/authenticate';

export default function RequestResetPassword() {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const onFinish = async (value) => {
    setIsLoading(true);
    try {
      await requestRequestResetPasswordApi(value);
      form.resetFields();
      message.success('A password reset confirmation has been sent to your email address.', 6);
    } catch (error) {
      const errMessage = Object.values(error.error?.response?.data?.details || {})?.[0];
      message.error(errMessage || error.error?.response?.data?.message || 'Something went wrong!');
    }
    setIsLoading(false);
  };

  return (
    <div className="login-page">
      <Row align="middle" justify="center" className="wrapper">
        <Col xs={24} sm={12} md={8} className="login-form">
          <Card>
            <img className="logo" alt="PETstock New Zealand logo" src={Logo} />
            <Form
              form={form}
              name="basic"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              initialValues={{ remember: true }}
              className="form-content"
              onFinish={onFinish}
            >
              <Form.Item
                label="Email"
                name="email"
                labelAlign="left"
                rules={[{ required: true, message: 'Please input your email!' }]}
              >
                <Input />
              </Form.Item>

              <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button loading={isLoading} size="large" htmlType="submit">
                  Continue
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
